import { render } from "./LikeIcon.vue?vue&type=template&id=b3134e9e&scoped=true"
import script from "./LikeIcon.vue?vue&type=script&lang=js"
export * from "./LikeIcon.vue?vue&type=script&lang=js"

import "./LikeIcon.vue?vue&type=style&index=0&id=b3134e9e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3134e9e"]])

export default __exports__